import styled from 'styled-components';

export const DeliveryDateSelector = styled.div`
  flex-direction: column;
  gap: 2px;
  display: flex;
`;

export const DateDisplay = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: #f78e1e;
  cursor: pointer;
`;

export const Text = styled.span<{ $small?: boolean }>`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: ${({ small }) => (small ? '0.625rem' : '0.875rem')};
  color: ${({ small }) => (small ? '#8c8c8c' : '#f78e1e')};
`;
